var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app" }, [
    _c(
      "div",
      { staticClass: "app-header navbar p-1" },
      [
        _c(
          "b-row",
          { staticStyle: { width: "100%" } },
          [
            _c("b-col", { staticClass: "text-center", attrs: { sm: "2" } }, [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.svg.logo) } })
            ]),
            _vm._v(" "),
            _c("b-col", { staticClass: "text-center", attrs: { sm: "8" } }, [
              _c("h3", { staticClass: "header-title" }, [
                _vm._v("Medical Insurance Cards Processing using Document AI")
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { sm: "2" } },
              [
                _c(
                  "b-navbar-nav",
                  {
                    staticStyle: {
                      "flex-direction": "column",
                      "padding-top": "10px"
                    }
                  },
                  [_c("MicpHeaderAccount")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "app-body" }, [
      _c(
        "div",
        { staticClass: "container-fluid p-0" },
        [
          _c(
            "b-row",
            { staticClass: "m-0", staticStyle: { width: "100%" } },
            [
              _c(
                "b-col",
                { staticClass: "col-sm-12 p-0" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "m-0",
                      staticStyle: { "font-size": "16px" }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "col-sm-12 col-md-10 text-center",
                              attrs: { "offset-md": "1" }
                            },
                            [
                              _vm._v(
                                "\n                This solution processes insurance card images that are uploaded, and it extracts the data using Google Document AI. For demonstration purposes, we are processing / extracting limited fields. This solution can be extended to different types of inputs like driver licenses, large forms, invoices and more.\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "m-0", staticStyle: { width: "100%" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "col-sm-12 col-md-8 p-0 pt-1 pr-1",
                  staticStyle: { height: "520px" }
                },
                [
                  _c(
                    "b-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c("b-card-body", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "350px",
                              "overflow-y": "scroll"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "p-3 text-center text-secondary" },
                              [
                                _c("h4", [
                                  _vm._v(
                                    "Upload a scanned copy of insurance card to process"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("h6", [
                                  _vm._v(
                                    "Note: Allowed formats are only pdf and image ( jpg, jpeg, png )"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "m-3" },
                              [
                                _vm.isDropzoneBlank
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-danger upload-file-error"
                                      },
                                      [_c("b", [_vm._v("Please add a file.")])]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canShowDropZone
                                  ? _c("vueDropzone", {
                                      ref: "micpProcessDropZone",
                                      class:
                                        _vm.currentState === "upload"
                                          ? null
                                          : "d-none",
                                      attrs: {
                                        id: "dropzone",
                                        options: _vm.dropzoneOptions
                                      },
                                      on: {
                                        "vdropzone-file-added":
                                          _vm.onAddingFile,
                                        "vdropzone-sending": _vm.sendingEvent,
                                        "vdropzone-max-files-exceeded":
                                          _vm.onExceedingMaxFiles,
                                        "vdropzone-removed-file":
                                          _vm.onRemovingFile,
                                        "vdropzone-success":
                                          _vm.processResponse,
                                        "vdropzone-error": _vm.displayError
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    class:
                                      _vm.currentState === "processing"
                                        ? null
                                        : "d-none"
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-card",
                                          { staticClass: "process-loading" },
                                          [
                                            _c(
                                              "content-placeholders",
                                              [
                                                _c("content-placeholders-img", {
                                                  style: { height: "150px" }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.currentState === "processed"
                                  ? _c("div", { staticClass: "p-3" }, [
                                      _c("img", {
                                        staticClass: "processed-image",
                                        attrs: { src: _vm.imageUrl }
                                      })
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "upload-button",
                                attrs: {
                                  variant: "secondary",
                                  disabled: !_vm.isUploadEnabled
                                },
                                on: { click: _vm.processFile }
                              },
                              [
                                _vm.currentState === "processing"
                                  ? _c("i", {
                                      staticClass: "fa fa-spinner fa-spin mr-2",
                                      staticStyle: { "font-size": "18px" }
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.buttonState) +
                                    "\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "col-sm-12 col-md-4 p-0 pt-1 pl-1",
                  staticStyle: { height: "520px" }
                },
                [
                  _c(
                    "b-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { staticClass: "col-10 pull-left" }, [
                                _c("h5", [_vm._v("Results")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { staticClass: "col-2" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "download-button",
                                      attrs: {
                                        title: "Download JSON",
                                        variant: "secondary",
                                        size: "sm",
                                        disabled: !_vm.isDownloadEnabled
                                      },
                                      on: { click: _vm.downloadJSON }
                                    },
                                    [_c("i", { staticClass: "fa fa-download" })]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        { staticClass: "process-results" },
                        _vm._l(_vm.processedResults, function(value, key) {
                          return _c(
                            "b-row",
                            { key: key, staticClass: "processed-value" },
                            [
                              _c("b-col", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm._f("titlize")(key)) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-col", { staticClass: "col-8" }, [
                                _vm._v(
                                  "\n                  : " +
                                    _vm._s(value) +
                                    "\n                "
                                )
                              ])
                            ],
                            1
                          )
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "footer",
        { staticClass: "app-footer d-flex footer-style" },
        [
          _c(
            "b-row",
            { staticStyle: { width: "100%" } },
            [
              _c("b-col", { attrs: { sm: "2" } }, [
                _c("h5", { staticClass: "contact-us" }, [_vm._v("Contact Us:")])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { sm: "8" } }, [
                _c("h5", [
                  _c(
                    "a",
                    {
                      staticClass: "mail-to",
                      attrs: { href: "mailto:sureshr@wilcolabz.com" }
                    },
                    [_vm._v("sureshr@wilcolabz.com")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("4677 Old Ironsides Dr, Santa Clara, CA 95054")
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4165fb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4165fb0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/micp/micpDemo.vue
// module id = 1445
// module chunks = 2